// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/CoE/base.scss
// module id = 1261
// module chunks = 0